import MediaQuery from 'react-responsive'
import { useDeviceType } from '../../contexts/device-type'
import { DeviceType } from '../../constants'

const SSR_WIDTH = {
  [DeviceType.Mobile]: 375,
  [DeviceType.Desktop]: 1280,
}

export function Desktop({ children }) {
  const deviceType = useDeviceType()
  const device = { width: SSR_WIDTH[deviceType] ?? 1280 }

  return (
    <MediaQuery query="(min-width: 1025px)" device={device}>
      {children}
    </MediaQuery>
  )
}

export function Mobile({ children }) {
  const deviceType = useDeviceType()
  const device = { width: SSR_WIDTH[deviceType] ?? 1280 }

  return (
    <MediaQuery query="(max-width: 1024px)" device={device}>
      {children}
    </MediaQuery>
  )
}
